// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__-lqpq","label":"Completed_label__2OxYO"};